/* Dr. Ahmed Amr theme scripts */
(function () {
  // ===== mobile nav =====
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var nav = document.getElementById('mobile-nav');
      if (nav) nav.classList.toggle('open');
    }
  });

  // ===== offer popup =====
  function pad(n) { return String(n).padStart(2, '0'); }
  var popup = document.getElementById('offer-popup');
  if (popup) {
    var endsAt = popup.getAttribute('data-ends-at');
    var end = endsAt ? new Date(endsAt).getTime() : 0;
    var cd = popup.querySelector('[data-countdown]');
    function left() { return end - Date.now(); }
    function render() {
      var d = left();
      if (d <= 0) { popup.classList.remove('open'); if (cd) cd.style.display = 'none'; return; }
      if (!cd) return;
      cd.querySelector('[data-d] b').textContent = pad(Math.floor(d / 86400000));
      cd.querySelector('[data-h] b').textContent = pad(Math.floor(d / 3600000) % 24);
      cd.querySelector('[data-m] b').textContent = pad(Math.floor(d / 60000) % 60);
      cd.querySelector('[data-s] b').textContent = pad(Math.floor(d / 1000) % 60);
    }
    if (left() > 0) { popup.classList.add('open'); render(); setInterval(render, 1000); }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-popup]')) popup.classList.remove('open');
    });
  }

  // ===== cart =====
  var drawer = document.getElementById('cart-drawer');
  function openDrawer() { if (drawer) drawer.classList.add('open'); }
  function closeDrawer() { if (drawer) drawer.classList.remove('open'); }

  function money(cents) {
    return (cents / 100).toLocaleString('ar-EG', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function renderCart(cart) {
    var counts = document.querySelectorAll('[data-cart-count]');
    counts.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? 'flex' : 'none';
    });
    if (!drawer) return;
    var list = drawer.querySelector('[data-cart-items]');
    var total = drawer.querySelector('[data-cart-total]');
    var checkout = drawer.querySelector('[data-checkout]');
    if (total) total.textContent = money(cart.total_price);
    if (checkout) checkout.disabled = cart.item_count === 0;
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p class="muted">السلة فاضية.</p>';
      return;
    }
    list.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="">' : '';
      return '<div class="citem">' + img +
        '<div style="flex:1"><div class="t">' + i.product_title + '</div>' +
        '<div class="p">' + money(i.final_line_price) + ' ' + (window.__currency || 'ج.م') + '</div></div>' +
        '<div style="display:flex;gap:6px;align-items:center">' +
        '<button class="icon-btn" data-qty="' + i.key + '" data-to="' + (i.quantity - 1) + '">−</button>' +
        '<span>' + i.quantity + '</span>' +
        '<button class="icon-btn" data-qty="' + i.key + '" data-to="' + (i.quantity + 1) + '">+</button>' +
        '</div></div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); fetchCart(); return; }
    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }
    var qty = e.target.closest('[data-qty]');
    if (qty) { changeLine(qty.getAttribute('data-qty'), parseInt(qty.getAttribute('data-to'), 10)); return; }
    if (e.target.closest('[data-checkout]')) { window.location.href = '/checkout'; }
  });

  // ajax add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'جاري الإضافة...'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { openDrawer(); return fetchCart(); })
      .catch(function () { alert('حصلت مشكلة، حاول تاني.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
  });

  fetchCart();
})();
